import { motion, AnimatePresence } from "motion/react";
import { ArrowUp, Clock, MousePointerClick, Sparkles, UserPlus } from "lucide-react";
import { formatIDR } from "@/lib/board-constants";

export type ActivityItem = {
  amount: number;
  total_after: number;
  created_at: string;
  name: string;
  slug: string;
};

function timeAgo(iso: string) {
  const diff = Date.now() - new Date(iso).getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return "baru saja";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m lalu`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}j lalu`;
  return `${Math.floor(hours / 24)}h lalu`;
}

export function ActivityFeed({ items }: { items: ActivityItem[] }) {
  return (
    <section className="py-2">
      <div className="flex items-center gap-2">
        <Sparkles className="size-4 text-primary" />
        <h2 className="font-display text-lg font-semibold tracking-tight">Aktivitas terbaru</h2>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">Update live dari bid dan listing baru.</p>

      <ul className="mt-3 space-y-2">
        <AnimatePresence mode="popLayout">
          {items.slice(0, 6).map((item, i) => (
            <motion.li
              key={`${item.slug}-${item.created_at}-${i}`}
              layout
              initial={{ opacity: 0, x: 12 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -12 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="surface-card flex items-center gap-3 rounded-xl px-3 py-2.5"
            >
              <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-primary-soft text-accent-foreground">
                <ArrowUp className="size-4" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">
                  <span className="text-foreground">{item.name}</span>{" "}
                  <span className="text-muted-foreground">naik bid</span>{" "}
                  <span className="font-semibold text-primary">{formatIDR(item.amount)}</span>
                </p>
                <p className="mt-0.5 flex items-center gap-2 text-[11px] text-muted-foreground">
                  <Clock className="size-3" />
                  {timeAgo(item.created_at)}
                  <span className="inline-flex items-center gap-1">
                    <MousePointerClick className="size-3" /> total {formatIDR(item.total_after)}
                  </span>
                </p>
              </div>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>

      {!items.length && (
        <div className="surface-card mt-3 flex items-center gap-3 rounded-xl px-3 py-3 text-muted-foreground">
          <UserPlus className="size-4 text-primary" />
          <p className="text-xs">Belum ada aktivitas bid. Jadilah yang pertama naikkan peringkat!</p>
        </div>
      )}
    </section>
  );
}
